import React from 'react';

import { H2, H5 } from '../../components';

import css from './SectionTrustedPartner.module.css';
import { ReactComponent as VastNetworkSVG } from '../../assets/svg/vast-network.svg';
import { ReactComponent as ProductRangeSVG } from '../../assets/svg/product-range.svg';
import { ReactComponent as SeamlessCommunicationSVG } from '../../assets/svg/seamless-communication.svg';
import { FormattedMessage } from 'react-intl';

const SectionTrustedPartner = props => {
  return (
    <article className={css.root}>
      <H2 as="h2" className={css.articleHeader}>
        <FormattedMessage id="LandingPage.yourTruestedPartner" />
      </H2>
      <p className={css.articlePara}>
        <FormattedMessage id="LandingPage.yourTruestedPartnerGrw" />
      </p>
      <section className={css.gridContainer}>
        <div className={css.container}>
          <VastNetworkSVG />
          <H5 as="h4">
            <FormattedMessage id="LandingPage.vastNetwork" />
          </H5>
          <p>
            <FormattedMessage id="LandingPage.vastNetworkPg" />
          </p>
        </div>
        <div className={css.container}>
          <ProductRangeSVG />
          <H5 as="h4">
            <FormattedMessage id="LandingPage.productRange" />
          </H5>
          <p>
            <FormattedMessage id="LandingPage.productRangePg" />
          </p>
        </div>
        <div className={css.container}>
          <SeamlessCommunicationSVG />
          <H5 as="h4">
            <FormattedMessage id="LandingPage.communication" />
          </H5>
          <p>
            <FormattedMessage id="LandingPage.communicationPg" />
          </p>
        </div>
      </section>
    </article>
  );
};

export default SectionTrustedPartner;
